import { IAppInsightsModel } from '../../models/appInsights/appInsightsModel';

// IoC pattern like a Service Locator of instantiating a singleton service with abstractization of the implementation
// benefits: very easy to mock in tests, by providing a mock implementation of the interface (IAppInsightsModel)
export class AppInsightsInstanceResolver {
    private static _insightsInstance: IAppInsightsModel;

    public static Instantiate(AppInsightsInstance: IAppInsightsModel) {
        if (!this._insightsInstance) {
            this._insightsInstance = AppInsightsInstance;
        }

        return this._insightsInstance;
    }

    public static get Instance() {
        return this._insightsInstance;
    }
}
